import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';

const DeleteCommentButton = (props) => {
  const deleteComment = async () => {
    if (confirm('Are you sure you want to delete this comment? This action cannot be undone.')) {
      try {
        await axios.delete(`/ajax/audio/${props.audioId}/comment/${props.commentId}`);
        await props.commentDeletedHandler();
      } catch {
        // Ignore failed delete, the comment will still be there.
      }
    }
  };

  return (
    <a
      type="button"
      className="text-decoration-none text-body margin-left-auto fs-5"
      onClick={deleteComment}
    >
      <i className="icon-bin"></i>
    </a>
  );
};

DeleteCommentButton.propTypes = {
  audioId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  commentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  commentDeletedHandler: PropTypes.func,
};

export default DeleteCommentButton;
